import * as React from 'react';
import { Popover } from 'antd';
// import { Player } from 'video-react';
import './index.css';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [
        {
          value: 'http://minio.demo.cqxyy.org.cn/public/%E6%A3%8D%E6%A3%8D%E2%80%94%E4%B8%80%E4%B8%AA%E7%94%9F%E7%89%A9%E5%8C%BB%E5%AD%A6%E7%9F%A5%E8%AF%86%E9%A2%97%E7%B2%92%E6%8C%96%E6%8E%98%E6%9C%BA%E5%99%A8%E4%BA%BA.mp4',
          id: 1,
          label: '您想要快速了解一个陌生领域的相关基因、疾病、药物、病理生理表型和信号通路吗？您想要了解感兴趣的领域中的表型与机制，或其他不同研究内容之间的潜在因果联系吗？您想要在关键领域中快速获得 “新”基因和“新”机制，掌握先机抢先获得研究成果吗？',
          title: '棍棍：挖掘生物医学知识颗粒的机器人'
        },
        {
          value: 'http://minio.demo.cqxyy.org.cn/public/%E6%A3%8D%E6%A3%8D%E5%B8%A6%E4%BD%A0%E8%A7%A3%E8%AF%BB%E5%9B%B0%E6%89%B0%E6%97%A5%E6%9C%AC%E9%A6%96%E7%9B%B8%E7%9A%84%E6%BA%83%E7%96%A1%E6%80%A7%E7%BB%93%E8%82%A0%E7%82%8E.mp4',
          id: 2,
          label: '8月28日，日本首相安倍晋三因溃疡性结肠炎复发，辞去首相一职。是什么病导致安倍连首相都不做了？棍棍花了几个小时挖掘了关于“inflammatory bowel disease”的两万篇综述并进行了归纳和推理，然后棍棍姐姐又花了一两个小时来了解棍棍的总结，在这个视频里为大家做了一个专业科普。',
          title: '棍棍带你解读困扰日本首相的溃疡性结肠炎'
        },
        {
          value: 'http://minio.demo.cqxyy.org.cn/public/%E5%85%B3%E4%BA%8ECD47%E7%9A%84%E4%B8%80%E5%88%87%E7%9F%A5%E8%AF%86.mp4',
          id: 3,
          label: 'CD47是号称下一代免疫药物靶点，“别吃我”信号通路通过CD47单抗阻断后，可能大大提高了抗原递呈效率和T细胞的敏感性，棍棍总结了关于CD47的一切知识，分享给大家。',
          title: '关于CD47的一切'
        },
      ],
      currentKey: 1
    };
  }
  onchangeCurrentKey = (type) => {
    let currentKey = this.state.currentKey;
    if (type === 'right') {
      this.setState({ currentKey: currentKey + 1 });
    }
    if (type === 'left') {
      this.setState({ currentKey: currentKey - 1 });
    }
  }
  getWords = () => {
    return (
      <div style={{ width: '9rem' }}>
        <div style={{ fontWeight: 800 }}>知识颗粒</div>
        <div>
          <p>知识颗粒(knowledge particle，KP)是棍棍根据特定信息在特定文献中的统计分布提取出来的结构化信息复合体，包括以下内容：</p>
          <p>• Summary：机器针对当前KP推荐的一句话，包含了当前KP的单位最大信息量（by words in the sentence）和当前KP的最大信息量（by sentence）；</p>
          <p>• Historical Trend of Research Interest: 针对当前KP相关内容，按月给出信息量的变化曲线，可以直观反映当前研究的热度变化；</p>
          <p>• Entities Representing Context(ERC): 与对照语料库相比后提取出来的实体，可以用来特异性表示当前主题中的某一方向；</p>
          <p>• Entities Enriched in Context(EEC): 在当前主题相关文本语料库中提取出来的实体，可以用来充分且必要地表示当前知识颗粒中的内容；</p>
          <p>• Associated Genes: 采用一组权重表示一组与当前主题相关的特定基因参与当前KP的表现度；</p>
          <p>• Signaling Pathway Enrichment: 根据上述基因的表现度在近200条信号通路中推断最相关通路；</p>
          <p>• Index of Well-Studied: 针对部分KP，可以根据明信息与暗信息*之间的关系，推断当前KP相关研究是否已经成熟，“成熟”意味着暗信息未包含较明信息更多的新信息。“不成熟”则有两种情况: （1）暗信息提供了明信息不包含的新信息，（2）暗信息与明信息矛盾。</p>
          <p>* 暗信息是指单从文献是看不到这些信息的存在；而是通过这里展示的方法，把所有知识整合起来才能就能找到的信息。</p>
        </div>
      </div>
    );
  }
  render() {
    const { currentKey, videos } = this.state;
    console.log('currentKey: ', currentKey);
    return (
      <React.Fragment>
        <link rel="stylesheet" href="https://video-react.github.io/assets/video-react.css" />

        <div className="index-box">
          <div className="bj-bj"><div className="index-bj"></div></div>

          <div className="title-bj">
            <div className="index-title">
              {
                currentKey === 1 &&
                videos[0].title
              }
              {
                currentKey === 2 &&
                videos[1].title
              }
              {
                currentKey === 3 &&
                videos[2].title
              }
            </div>
            <div className="video">
              <div className="video-box">
                {
                  currentKey > 1 &&
                  <div className="left" onClick={() => { this.onchangeCurrentKey('left') }}></div>
                }
                {
                  currentKey === 1 &&
                  <div className="leftDis"></div>
                }
              </div>
              {currentKey === 1 &&
                <video className="video-flv" src={videos[0].value} autoPlay='autoPlay' muted loop controls="controls" >
                  当前浏览器不支持
                </video>
              }
              {currentKey === 2 &&
                <video className="video-flv" src={videos[1].value} autoPlay='autoPlay' muted loop controls="controls" ></video>
              }
              {currentKey === 3 &&
                <video className="video-flv" src={videos[2].value} autoPlay='autoplay' muted loop controls="controls" ></video>
              }
              <div className=" video-img">
                {
                  currentKey < 3 &&
                  <div className="left" onClick={() => { this.onchangeCurrentKey('right') }}></div>
                }
                {
                  currentKey === 3 &&
                  < div className="leftDis"></ div>
                }
                {/* <div className="left"></div> */}
              </div>
            </div>
            <div className="ref">
              {
                currentKey === 1 &&
                <div className="text">
                  {videos[0].label}
                </div>
              }
              {
                currentKey === 2 &&
                <div className="text">
                  {videos[1].label}
                </div>
              }
              {
                currentKey === 3 &&
                <div className="text">
                  {videos[2].label}
                </div>
              }
            </div>
          </div>
          <div className="cont-bj">
            <div className="cont-cont">
              <img src="/img/gg-bj.png" className="gg" alt="" />
              <div className="cont-box">
                <div className="name-text">
                  <div className="txt">TWiRLs</div>
                  <div className="name">棍棍</div>
                </div>
                <div className="k-text">
                  <p>自2009年起，人类每年耗费133.68太瓦时（一太瓦时等于十亿度电）挖掘比特币，为世界带来一种全新的匿名交易方式，但并未提高人类对世界的认知。
                    我们赞赏对数字资源挖掘的前瞻性努力，但是我们更希望构建可以真实推动社会进步的挖掘能力，例如一种产生全新生物医学洞见的数字化资源挖掘系统。
                    人类在生命科学与医学领域已经沉淀了海量知识，但生物医学文献中包含海量的离散、稀疏、非结构化且不能定量的寡信息文本，
                    并且内容经常不一致甚至相互矛盾，生产这些内容的科学家之间也缺乏沟通和共识。研究者或许能从若干篇文献中获益，但基本不可能从一万篇文献中汲取有效信息。
                    因此，为了将特定科学领域全局文献中有价值的成分开采出来，我们采用大规模生物医学文献挖掘机器人（棍棍）进行挖掘整理，
                    并提供了“
                    <Popover
                      content={this.getWords()}
                      title=""
                    >
                      <span style={{ color: '#359cfd', cursor: 'pointer' }}>知识颗粒</span>
                    </Popover>
                    ”这种全新的知识展示方式- 将特定主题内容经挖掘整理后展示为多维度、可定量、携带机制与<span className="font-bold" style={{ fontSize: '0.14rem' }}>研究价值</span>的结构化信息复合体。
                    我们欢迎大家使用棍棍创造性地生产自己感兴趣的知识颗粒，不仅为你提供了全新的研究范式体验，同时也帮助你在你的研究领域中获得领先地位。</p>

                  <p><span className="font-bold">• 自动化归纳知识主题</span>---从复杂多维且非结构化的海量文献中提取出多维且高度结构化的知识颗粒，从多角度、更全面、更系统地了解当前主题的一个细分的领域。</p>
                  <p><span className="font-bold">• 构建人类可掌握的知识体系</span>---立足生物学、统计学和计算科学智能化，融合多种数据源，将特定话题文献中所包含的上百万文字总结成多个知识颗粒，
                    重新定义了一种人类个体就能掌握的知识体系。</p>
                  <p><span className="font-bold">• 快速掌握主题研究价值</span>---每个知识颗粒都携带了研究热度，客观反映特定研究方向随时间变化的趋势和研究者关切程度，指出该研究方向是研究者持续关注的“热点”，还是昙花一现的“假象”。</p>
                  <p><span className="font-bold">• 提供基因与通路机制信息</span>---每个知识颗粒都携带特定基因和信号通路的机制性信息，依据这些信息并结合自己的数据，研究者可以更加快速与深入地构建特定生物医学机制性模型。</p>
                  <p><span className="font-bold">• 精准评估研究成熟度</span>---一个知识颗粒中内容被研究的越充分，则其中包含的明信息越多，暗信息越少。不同知识颗粒包含的明信息与暗信息的比例不同，该比例的统计特征即可代表特定研究方向的成熟度，帮助研究者制定研究决策。</p>
                  <p><span className="font-bold">• 高效匹配投稿期刊</span>---不同知识颗粒富集不同期刊特征，有助于用户理性选择投稿期刊，将自己的稿件修改至符合特定期刊特征，做到精确投稿。</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bto-bj">
            {/* <div className="bot-name">ABOUT US</div> */}
            <div className="bot-name">关于我们</div>
            <div className="bto-txt">
              <p style={{ fontSize: '0.16rem', textAlign: 'justify', lineHeight: '0.32rem' }}>
                TWIRLS（棍棍）是一种大规模生物医学文献挖掘机器人，由北京哲源科技有限责任公司与图灵达尔文实验室联袂推出。
              </p>
              <p style={{ fontSize: '0.16rem', textAlign: 'justify', lineHeight: '0.32rem' }}>
                图灵-达尔文实验室创建于中国科学院计算技术研究所高性能计算中心，是中国科学院计算技术研究所在生命与信息交叉方向近二十年能力积累的产业化向生物医学延伸的出口。
              </p>
              <p style={{ fontSize: '0.16rem', textAlign: 'justify', lineHeight: '0.32rem' }}>
                哲源科技孵化于中国科学院计算技术研究所，作为以数字生命技术赋能医药创新的平台型公司，拥有领先的生命功能的数字孪生技术，并致力于构建“药物数字试验场”，为医药研发引入人工智能的新范式，为人类健康保驾护航。
              </p>
              <p style={{ fontSize: '0.16rem', textAlign: 'justify', lineHeight: '0.32rem' }}>
                本平台由中科计算技术西部研究院提供技术支持。
              </p>
              {/* <p style={{ fontSize: '0.16rem', textAlign: 'justify', lineHeight: '0.32rem' }}>
                图灵-达尔文实验室创建于中国科学院计算技术研究所高性能计算中心，是中国科学院计算技术研究所在生命与信息交叉方向近二十年能力积累的产业化向生物医学延伸的出口。在数据刻画一切的时代，图灵-达尔文实验室首倡并致力于发展“计算医学”，以信息科学与生物医学跨学科知识融合为基础，以系统性思维为指导思想，以数据密集型科学为范式，以人工智能为方法，以高性能计算为支撑，释放生物医学大数据生产要素价值，赋能药物研发与精准医疗，协助提升药物临床试验成功率、扩展药物适应症、挽救研发失败药物、提高临床用药精准性。
              </p> */}
              {/* <p style={{ fontSize: '0.16rem', lineHeight: 1.6, textAlign: 'justify', textIndent: '0.35rem' }}>
                在算法层面，图灵-达尔文实验室基于系统论的思想来理解基因组整体功能，而非个别的基因位点和片段，现已建立了400多个生命事件模型，把基因组上离散的、罕见的变异投射在连续的、丰富的特征空间上，系统地理解变异的生物学功能。该过程用几千个CPU,迭代了数千次,并经过生物学实验的验证。该技术是独特的、国际领先的。在药物靶点发现、适应症选择和优势人群选择上得到广泛应用。实践表明，图灵-达尔文实验室的算法模型效果显著，正设计包括专利和技术秘密(一系列know-how)等一系列保护措施。
              </p>
              <p style={{ fontSize: '0.16rem', lineHeight: 1.6, textAlign: 'justify', textIndent: '0.35rem' }}>
                在算力技术层面，图灵-达尔文实验室发展了模式驱动的领域专用加速算法优化技术以适配生物信息学的数据密集型应用，大幅提升非数值计算应用的数据处理速度，并率先成功将领域专用加速计算进行实际应用。图灵-达尔文实验室设计了一系列算力技术包括在国际上首次设计了cache-oblivious动态规划算法、以提升数据局部性为目标，优化以序列比对和变异位点计算为核心的索引和图数据模型向体系结构的映射实现等。图灵-达尔文实验室的算力技术来源于计算所的曙光团队，该团队超级计算机的计算峰值曾经夺得世界第一。
                </p> */}
            </div>
          </div>
        </div>
      </React.Fragment >
    );
  }
}

export default Index;
